/** Longest beta or invite code we accept once any pasted link has been stripped away. */
export const MAX_CODE_LENGTH = 32;

/**
 * Turn whatever someone pasted into a beta/invite code box into the bare code.
 * People often paste the whole link (`https://…/?invite=AB12CD&beta=XY34`), so pull the
 * `param` value out of it when it's there; otherwise use the text as typed.
 */
export function extractCode(raw: string, param: 'beta' | 'invite'): string {
  const s = raw.trim();
  const m = s.match(new RegExp(`[?&#]${param}=([A-Za-z0-9-]+)`, 'i'));
  return (m ? m[1] : s).toUpperCase();
}
